import PropTypes from 'prop-types';
import { isSmall } from 'screen-helper';
import classnames from 'classnames';

import Overlay from './overlay';
import MessageBox from './message_box';

const Modal = (props) => {
  const {
    actionSheet,
    className: classNameProp,
    overlayFullscreen,
    modalClassName,
    onCloseClick,
    ignoreOverlayClick,
  } = props;

  const className = classnames({
    'bvs-modal': true,
    'is-action-sheet': actionSheet,
    [classNameProp]: true,
  });

  const wrapperClassName = classnames({
    'bvs-modal-container': true,
    [modalClassName]: true,
    [`${classNameProp}-wrapper`]: !!classNameProp,
  });

  return (
    <div className={wrapperClassName}>
      <Overlay
        fullscreen={overlayFullscreen}
        {...((isSmall() && onCloseClick && !ignoreOverlayClick)
          ? { onClick: onCloseClick }
          : {}
        )}
      />
      <MessageBox {...props} className={className} />
    </div>
  );
};

Modal.propTypes = {
  className: PropTypes.string,
  actionSheet: PropTypes.bool,
  onCloseClick: PropTypes.func,
  overlayFullscreen: PropTypes.bool,
  modalClassName: PropTypes.string,
  ignoreOverlayClick: PropTypes.bool,
};

Modal.defaultProps = {
  className: '',
  onCloseClick: undefined,
  actionSheet: false,
  overlayFullscreen: false,
  modalClassName: '',
  ignoreOverlayClick: false,
};

export default Modal;
